<div data-template="flexible" [ngClass]="{'row': pageWidth !== 'full'}">
  <div [ngClass]="{'col-lg-8 mx-auto': pageWidth !== 'full' }">
    <h1 [ngClass]="{'sr-only': pageInfo?.content?.hideTitle === 'true' }" tabindex="-1" [innerHtml]="pageTitle"
      [attr.aria-label]="pageTitle"></h1>
    <div *ngFor="let component of pageComponents" pbcApplyRules [visibilityRules]="component?.data?.visibilityRules" [rulesOperation]="component?.data?.visibilityRuleOperation" [ngClass]="component?.data?.content?.parentClasses" >
      <pbc-component-renderer [component]="component"></pbc-component-renderer>
    </div>
  </div>
</div>
